// Tier-2 <Drawer> backed by AntD Drawer (FORT-331). A side/edge panel that shares
// the Modal primitive's open/onClose contract. Structural wrapper — surface
// colours come from AntD's token-sourced theme, so no useTokens() here.
import React from 'react';
import { Drawer as AntDrawer } from 'antd';
import type { CommonProps } from './types';

export type DrawerPlacement = 'left' | 'right' | 'top' | 'bottom';

export interface DrawerProps extends CommonProps {
  open: boolean;
  onClose: () => void;
  title?: React.ReactNode;
  placement?: DrawerPlacement;
  /** Panel width for left/right placement. */
  width?: number | string;
  /** Panel height for top/bottom placement. */
  height?: number | string;
  footer?: React.ReactNode;
  closable?: boolean;
  /** Close when the backdrop is clicked. Defaults to true. */
  maskClosable?: boolean;
  children: React.ReactNode;
}

export const Drawer: React.FC<DrawerProps> = ({
  open,
  onClose,
  title,
  placement = 'right',
  width,
  height,
  footer,
  closable = true,
  maskClosable = true,
  children,
  className,
  style,
  'data-testid': dataTestId,
}) => (
  <AntDrawer
    open={open}
    onClose={onClose}
    title={title}
    placement={placement}
    width={width}
    height={height}
    footer={footer}
    closable={closable}
    maskClosable={maskClosable}
    destroyOnClose
    className={className}
    style={style}
    data-testid={dataTestId}
  >
    {children}
  </AntDrawer>
);
